const messages: Record<string, string> = {
	'button.next': 'Kontynuuj',

	'blockedByDevice.headline': 'Proszę użyć smartfona',
	'blockedByDevice.paragraph.first':
		'Ten link może być użyty tylko na smartfonach. Proszę zeskanować poniższy kod QR swoim smartfonem, aby rozpocząć wgrywanie zdjęć.',
	'blockedByDevice.paragraph.second':
		'Wskazówka: otwierając link, warto być w pobliżu pojazdu i mieć przy sobie dokumenty.',
	'onboardingStart.headline': 'Cześć! Sprawdź swoje dane, abyśmy mogli rozpocząć.',
	'onboardingStart.plateNumber': 'Numer rejestracyjny:',
	'onboardingStart.timeout': 'Link będzie ważny do ',
	poweredBy: 'Powered by <ce>ControlExpert</ce> a <solvd>Solvd</solvd> group company',

	'onboarding.headline': 'Czy jesteś gotowy na cyfrową inspekcję?',
	'onboarding.paragraph': 'Przed rozpoczęciem procesu weź pod uwagę następujące kwestie:',
	'onboarding.documents': 'Miej pod ręką <b>kluczyki</b> oraz <b>dowód rejestracyjny pojazdu</b>.',
	'onboarding.camera': 'Zdjęcia można wykonać wyłącznie za pomocą <b>aparatu smartfona</b>.',
	'onboarding.internet':
		'Znajdź się w miejscu z <b>dobrym oświetleniem</b> i <b>szybkim połączeniem internetowym</b>.',
	'onboarding.vehicle':
		'Upewnij się, że pojazd jest <b>czysty</b>, <b>dostępny ze wszystkich stron</b> oraz że wszystkie <b>okna są zamknięte</b>.',
	'onboarding.terms.before': 'Przed rozpoczęciem potwierdź następujące kwestie:',
	'onboarding.terms.url': 'Akceptuję <tclink>regulamin</tclink>.',

	'questions.DoesTheVehicleHaveCNG': 'Czy pojazd ma zamontowane CNG?',
	'questions.ArmoredVehicle': 'Pojazd opancerzony?',
	'questions.DoesTheVehicleHaveModifiedSuspension': 'Czy pojazd ma zmodyfikowane zawieszenie?',
	'questions.WasTheChassisNumberRemarked': 'Czy numer podwozia został ponownie oznaczony?',
	'questions.yes': 'Tak',
	'questions.no': 'Nie',
	'questions.paragraph':
		'Jeśli pojazd ma jakiekolwiek modyfikacje, które chcesz udokumentować, proszę odpowiedz na poniższe pytania:',
	'questions.title': 'Informacje o pojeździe',

	'fullscreen.prompt': 'Tryb pełnoekranowy zapewnia łatwiejsze robienie zdjęć.',
	'fullscreen.prompt.accept': 'Otwórz w trybie pełnoekranowym',
	'fullscreen.prompt.dismiss': 'Kontynuuj w trybie okienkowym',

	'vehicleFrontLeftPerspectiveImage.title': 'Zdjęcie przedniej lewej części pojazdu',
	'vehicleFrontLeftPerspectiveImage.description':
		'Wykonaj zdjęcie diagonalne z przodu po lewej stronie, upewniając się, że cały pojazd mieści się w kadrze oraz tablica rejestracyjna jest widoczna.',
	'vehicleFrontRightPerspectiveImage.title': 'Zdjęcie przedniej prawej części pojazdu',
	'vehicleFrontRightPerspectiveImage.description':
		'Wykonaj zdjęcie diagonalne z przodu po prawej stronie, upewniając się, że cały pojazd mieści się w kadrze oraz tablica rejestracyjna jest widoczna.',
	'vehicleRearLeftPerspectiveImage.title': 'Zdjęcie tylnej lewej części pojazdu',
	'vehicleRearLeftPerspectiveImage.description':
		'Wykonaj zdjęcie diagonalne z tyłu po lewej stronie, upewniając się, że cały pojazd mieści się w kadrze oraz tablica rejestracyjna jest widoczna.',
	'vehicleRearRightPerspectiveImage.title': 'Zdjęcie tylnej prawej części pojazdu',
	'vehicleRearRightPerspectiveImage.description':
		'Wykonaj zdjęcie diagonalne z tyłu po prawej stronie, upewniając się, że cały pojazd mieści się w kadrze oraz tablica rejestracyjna jest widoczna.',

	'dashboardMileage.title': 'Zdjęcie licznika przebiegu',
	'vehicleMileage.description':
		'Wykonaj zdjęcie licznika przebiegu, upewniając się, że zdjęcie jest ostre, a odczyt jest wyraźnie widoczny i czytelny.',
	'dashboardMileage.placeholder.updated': 'Wprowadź przebieg (km)',

	'windshieldImage.description':
		'Wykonaj zdjęcie przedniej szyby, upewniając się, że cały obszar szkła oraz jego detale są wyraźnie widoczne.',
	'vinPicture.description':
		'Wykonaj z bliska zdjęcie numeru VIN, upewniając się, że wszystkie znaki są czytelne.',
	'overallDashboardImage.description':
		'Wykonaj zdjęcie deski rozdzielczej, upewniając się, że wszystkie kontrolki i elementy są w pełni widoczne.',
	'button.photo.take': 'Zrób zdjęcie',

	'photoUploading.title': 'Wysyłanie',
	'photoAnalyzing.title': 'Analiza',
	'photoLoading.title': 'Ładowanie',
	'landscapeModeDetected.title': 'Automatyczne obracanie włączone',
	'landscapeModeDetected.text':
		'Proszę wyłączyć automatyczne obracanie na swoim urządzeniu, aby w celu wygodniejszego robienia zdjęć.',

	'button.changeImage': 'Zmień zdjęcie',
	'button.anotherImage': 'Wykonaj kolejne zdjęcie',
	'button.deleteImage': 'Usuń zdjęcie',
	'button.acceptImage': 'Akceptuj zdjęcie',
	'button.acceptMileage': 'Potwierdź',
	'photo.deleteConfirmation.title': 'Czy na pewno chcesz usunąć to zdjęcie?',
	'photo.deleteConfirmation.description':
		'Jeśli usuniesz to zdjęcie, konieczne będzie wykonanie nowego.',
	'photo.deleteConfirmation.confirm': 'Usuń zdjęcie',
	'photo.deleteConfirmation.cancel': 'Anuluj',
	'validationContainer.correct': 'Prawidłowe',

	'button.hint': 'Gdzie znajduje się numer VIN?',
	'hint.vin': 'XXXXXXXXXXXXXXXXX',
	'hint.vin.title': 'Możliwe miejsca umieszczenia VIN',
	'hint.vin.description': 'Zazwyczaj można go znaleźć w czterech miejscach:',
	'hint.vin.location1': 'Na desce rozdzielczej, widoczny przez przednią szybę po stronie kierowcy.',
	'hint.vin.location2': 'Na framudze drzwi po stronie kierowcy, w pobliżu zamka.',
	'hint.vin.location3': 'W komorze silnika, często na metalowej tabliczce.',
	'hint.vin.location4': 'W przedniej części ramy (w starszych pojazdach).',

	'additionalDamagePictures.title': 'Zdjęcia uszkodzeń',
	'damagedImages.description': 'Możesz dodać do {imageCount, number} zdjęć',
	'damagedImages.booleanRadioGroupLabel': 'Czy pojazd posiada jakieś uszkodzenia?',
	'damagedImages.booleanRadioGroupLabelLeft': 'Nie',
	'damagedImages.booleanRadioGroupLabelRight': 'Tak',

	'review.title': 'Podsumowanie cyfrowej inspekcji',
	'review.paragraph.first':
		'Przed zakończeniem sprawdź, czy wszystkie informacje są poprawne.<br/><br/>Po kliknięciu „Zakończ” potwierdzimy przesłane zdjęcia i dane.',
	'review.button.next': 'Zakończ',
	'review.stepDescription.group.perspectiveImages': 'Zdjęcia pojazdu',
	'review.stepDescription.vehicleFrontLeftPerspective': 'Zdjęcie przedniej lewej strony pojazdu',
	'review.stepDescription.vehicleFrontRightPerspective': 'Zdjęcie przedniej prawej strony pojazdu',
	'review.stepDescription.vehicleRearLeftPerspective': 'Zdjęcie tylnej lewej strony pojazdu',
	'review.stepDescription.vehicleRearRightPerspective': 'Zdjęcie tylnej prawej strony pojazdu',
	'review.stepDescription.group.additionalImages': 'Dodatkowe zdjęcia',
	'review.stepDescription.questions': 'Informacje o pojeździe',

	'thanks.headline.first': 'Otrzymaliśmy Twoje zdjęcia!',
	'thankYou.message': 'Twoje zgłoszenie jest weryfikowane przez zespół techniczny.',
	'feedback.title': 'Będziemy wdzięczni za opinię.',
	'feedback.message':
		'W skali od 0 do 5, jak oceniasz swoje doświadczenie z przeprowadzoną cyfrową inspekcją?',
	'feedback.helpImprove': 'Pomóż nam się poprawić (opcjonalnie):',
	'feedback.error.maxLength': 'Opinia nie może przekroczyć {maxLength} znaków.',

	'timeout.headline.first': 'Nie znaleziono twojego zgłoszenia.',
	'timeout.paragraph.first': 'Twoje zgłoszenie wygasło, lub użyty link jest nieprawidłowy.',
	'camera.darkWarning':
		'Otoczenie potencjalnie zbyt ciemne — popraw oświetlenie w celu uzyskania lepszej jakości zdjęcia.',
};

export default messages;
